export const cn = (...list) => list.filter(item => item).join(" ");
